/**
 * How a count reads on a badge.
 *
 * A badge is a small disc over a mark, so a number that keeps counting past
 * three digits stops fitting and starts overhanging the affordance beside it.
 * Beyond the ceiling it says "more than this" instead.
 */

/** Beyond this a badge stops counting and says so. */
export const DEFAULT_COUNT_CEILING = 99;

export const readableCount = (count: number, ceiling: number = DEFAULT_COUNT_CEILING): string =>
  count > ceiling ? `${String(ceiling)}+` : String(count);
